module.exports = __webpack_public_path__ + "static/media/wemi_registro_terrioriale-assistenti-familiari.9de1688a.pdf";